import Vue from "vue";
import VueRouter from "vue-router";
import routes1 from "./routes";
import store from '@/store';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  // mode: 'history',
  routes: routes1, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  console.log(arguments)
  
  Vue.prototype.$modal.hideAll()

  // 게시판 모듈인데 게시판 번호가 다르면 레이아웃 변경
  if(to.params.boardNo && from.params.boardNo && (to.params.boardNo !== from.params.boardNo) ) {

    // 게시판번호만 바꾸면 레이아웃 변경이 안되기때문에
    // 강제로 홈으로 간다음 setTimeout 을 이용해서 다른 게시판으로 이동 
    next('/') 
    setTimeout(()=>{
      router.push(to)
    },10)

    return
  }

  if (to.matched.some(m => m.meta.auth) && !store.state.auth.authenticated) {
    next({
      name: 'Home',
    });
  } else {
    if (to.matched.some(m => m.meta.auth) ) {
      store.dispatch('account/me');
    }
    next();
  }
});

Vue.router = router;

export default router;
